import React, { useState, useRef } from 'react';
import { useDrop } from 'react-dnd';
import { DragType } from '../DragBox';
import { DroppedBox } from '../DroppedBox';

interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onDrop'> {
    items?: any;
    onDrop?: any;
    multiple?: boolean;
    index?: any;
    type?: string;
    name?: string;
    css?: {backgroundColor?: string, borderStyle?: string, borderWidth: number};
    setCurrentExercise?: any
    isLogicMaker?: boolean;
    dropArea?: any
}
 
export const DropBox = ({ onDrop, items, children, multiple, index,type,name,setCurrentExercise,css,isLogicMaker,dropArea,...rest }: Props) => {
    const [isDropped, setIsDropped] = useState(false);
    const [droppedContent, setDroppedContent] = useState<DragType>({} as DragType);
    const pos = dropArea? dropArea.pos? dropArea.pos : {x:0,y:0} :  {x:0,y:0}
    const width = dropArea? dropArea.width : undefined
    const height = dropArea? dropArea.height : undefined
    const boardRef = useRef<HTMLDivElement | null>(null);

    const [, drop] = useDrop(() => ({
        accept: type || 'drag-box',
        drop: (item: DragType,monitor) => {
            if(type != "asset") {
               setIsDropped(true);
               setDroppedContent(item);
               item.setHide(true); //Hides the component that was dropped
               if (onDrop !== undefined) onDrop(item.items, items);
            } else {
                if (onDrop !== undefined) onDrop(item,{x: 0,y: 0});
        }
}}));


    const renderDropBox = () => {
        return (
            <>
                <div ref={drop} style={ isLogicMaker? {...css,  width: '100%',height: '100%'} : {...css,left: pos.x * window.innerWidth,top: pos.y * window.innerHeight,position: 'fixed', width: width * window.innerWidth , height: height * window.innerHeight }} {...rest}>
                    {children}

                    <label style={{ opacity: 0.45, paddingTop: '12vh',  position: 'absolute', color: 'blue'
 }}>{index && items.id}</label>
                </div>
            </>
        );
    };

    const renderDroppedContent = (content: DragType) => {
        if(type != "asset") {
            return (
                <>
                    <DroppedBox
                        setDragBoxHide={content.setHide}
                        setDropBoxContent={setDroppedContent}
                        setDropBoxDropped={setIsDropped}
                        dragItems={content.items}
                        className={content.className}
                        style={{...css,left: pos.x * window.innerWidth,top: pos.y * window.innerHeight,position: 'fixed', width: width * window.innerWidth , height: height * window.innerHeight }}
                    >
                        {content.children}
                    </DroppedBox>
                    <label
                        style={{
                            opacity: 0.45,
                            paddingLeft: '2.15vw',
                            top: '1.4vh',
                            position: 'absolute'
                        }}
                    >
                        {index && items.id}
                    </label>
                </>
            );

        } else {
            return <></>
        }
    };

    return isDropped && !multiple  ? renderDroppedContent(droppedContent) : renderDropBox();
};
